import { DateTime } from 'luxon'

/**
 * 募集期間中の場合trueを返す
 */
export const isAcceptingEntries = (offerStarted?: string, offerEnded?: string | null) => {
  if (!offerStarted) return false // 否認キャンペーンの中に一部offerStarted未設定あり。この場合は募集期間もないのでfalse

  const started = DateTime.fromISO(offerStarted).toMillis()
  const ended = offerEnded ? DateTime.fromISO(offerEnded).toMillis() : null
  const now = DateTime.local().toMillis()

  // 募集終了日が設定されていない場合
  if (!ended) return started < now
  // 募集終了日が設定されている場合
  return started < now && now < ended
}
